import { archive } from './archive';
import { credentials } from './credentials';
import { localUserSettings } from './localUserSettings';

export const localStorage = { archive, credentials, localUserSettings };
